// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1djVm","left":"styles_left__KH89w"};